module.exports = __webpack_public_path__ + "img/icon_map_10_on_010.05d2879b.png";